export default "/images/vendor/flag-icons/flags/1x1/ck.svg?3e6dd6ddd9eb71276bcb1f3be5741c31";